import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "./plugins/firebase";
import vuetify from "./plugins/vuetify";
import VueEditableGrid from "vue-editable-grid";
import "vue-editable-grid/dist/VueEditableGrid.css";

Vue.config.productionTip = false;

// register component in the Vue app
Vue.component("vue-editable-grid", VueEditableGrid);

Vue.use(firebase);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
